import ModalWrapper from '../../common/Modal/ModalWrapper'

const CompanyReferCfoOfferModal = () => {
    return (
        <ModalWrapper
            modalType={'companyReferCfoOfferModa'}
            modalCardClasses={'maw90'}
            customStyle={{
                padding: '0rem',
                overflow: 'hidden',
            }}
        >
            <div className='df w100'>
                <div className='pt2rem pb0rem pr2rem w70 pl4rem' style={{ backgroundColor: '#F5F7FF' }}>
                    <div className='df fdc aifs p2rem'>
                        <img src={require('../../../../images/referCfo/DiligentsianCfologo.png')} alt='referCfoOffer' style={{ maxWidth: '150px', width: '100%' }} />
                        <h2 className='c15 fs14px mb0-5rem tal w100 tal fw500'><span className='c34'>Diligentsia Plus</span> Offer</h2>
                    </div>

                    <div className='pt0rem pl1rem pr2rem'>
                        <h3 className='c4 fw400 mt2rem fs20px'>Want to benefit from some loss-leading services? </h3>
                        <h3 className='fs2rem c15 fw500 mt0-5rem'>We will match you with an experienced <br></br> fractional CFO for a fixed price package</h3>

                        <div className='mt4rem ml1rem'>
                            <ul>
                                <li className='c15'>
                                    Fixed price of only £500 plus VAT - all goes to the CFO*
                                </li>
                                <li className='c15'>
                                    <span className='fw600'>Why will they do this?</span>To build a pipeline of exciting companies who will return to them as they grow and can afford top commercial advice
                                </li>
                                <li className='c15'>
                                    <span className='fw600'> Why should you do this? </span> To build an early relationship with someone who in the years ahead will turboboost your business with their experience and contacts
                                </li>
                            </ul>
                        </div>

                        <p className='c49 fs1rem mt4rem mb1rem fw400'>
                            To get things rolling, please contact us to find out more and be matched...
                        </p>

                        <div className='df aic jcfs'>
                            <button style={{ maxHeight: "40px" }} onClick={() => window.open('https://koalendar.com/e/meet-with-mark-bernstein', '_blank')} className='df jcsb px1rem new-shadow cp c1 bg4 fw400 fs1rem br38px w200px py0-5rem'>
                                <div className='df aic'>
                                    <img className='mr0-5rem' src={require('../../../../images/referCfo/telephone.svg')} alt='telephone' />
                                    <span className="pl0-5rem fw400 c1 fs14px" >
                                        Book a Call
                                    </span>
                                </div>
                                <img src={require('../../../../images/referCfo/right-arrows.svg')} alt='rightArrow' />
                            </button>
                        </div>

                        <p className='c49 fs11px tac mt3rem'>*= Diligentsia does not take commission from the introduction, and takes no responsibility for advice provided or ommitted by the CFO</p>

                    </div>
                </div>

                <div
                    className='w30 pt1rem'
                    style={{ backgroundImage: "linear-gradient(to right, #B9D9F9, #7FBDFA)" }}
                >
                    <div
                        className='br8px p2rem df aic jcc fdc w80 mxa'
                        style={{ backgroundImage: "linear-gradient(to right, #FFFFFF33, #ffffff39)" }}
                    >

                        <div className='mb0-5rem df fdc aic jcc'>
                            <img className="mb0-5rem" style={{ width: '32px', height: '32px' }} src={require("../../../../images/referCfo/refer.png")} alt="cfoCenterRefer" />
                            <h3 className='c15 fs14px'>Quarterly Check-ins</h3>
                            <p className='c49 fs11px tac'> First meeting - one hour review of your business and Diligentsia modules then 3 x quarterly reviews over the rest of the year</p>
                        </div>

                        <div className='mb0-5rem df fdc aic jcc'>
                            <img className="mb0-5rem" style={{ width: '32px', height: '32px' }} src={require("../../../../images/referCfo/fraction.png")} alt="cfoCenterFraction" />
                            <h3 className='c15 fs14px'>Platform Experts</h3>
                            <p className='c49 fs11px tac'>The CFOs we match you with are already experts in the Diligentsia platform​</p>
                        </div>

                        <div className='mb0-5rem df fdc aic jcc'>
                            <img className="mb0-5rem" style={{ width: '32px', height: '32px' }} src={require("../../../../images/referCfo/refund.png")} alt="cfoCenterRefund" />
                            <h3 className='c15 fs14px'>High-Value Guidance</h3>
                            <p className='c49 fs11px tac'>The matched CFOs will give you bags of advice - vast amounts of value</p>
                        </div>

                    </div>

                    <div className='w100 df'>
                        <img className='w100' src={require('../../../../images/referCfo/referOfferRightIcon.png')} alt="referOfferRightIcon" />
                    </div>

                </div>
            </div>


        </ModalWrapper>
    )
}

export default CompanyReferCfoOfferModal